import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import ReactApexChart from 'react-apexcharts';

export default function PaymentSummary({filter , fetchedData,listPayment}) {
    // const [listPayment, setListPayment] = useState([]);

//     useEffect(() => {
//         if(fetchedData){
//  fetchData();
//         }
//     }, [fetchedData]);

//     const fetchData = async () => {
//         try {
//             const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Dashboard/DashboardPaymentSummary?Month=${filter?.month}&Year=${filter?.year}`, {
//                 headers: {
//                     "Content-Type": "application/json",
//                     Authorization: `Bearer ${localStorage.getItem("user_token")}`,
//                 },
//             });
//             setListPayment(response?.data?.response || []);
//         } catch (error) {
//             console.log("error", error);
//         }
//     };
  const [hiddenTerms, setHiddenTerms] = useState([]);

  // ✅ 20 consistent colors
  const colorPalette = [
    "#60B564", "#22C3D7", "#FFA320", "#D97757", "#EE504D",
    "#8A8D91", "#B5B5B5", "#7F56D9", "#2D9CDB", "#27AE60",
    "#F2994A", "#EB5757", "#BB6BD9", "#56CCF2", "#219653",
    "#F2C94C", "#9B51E0", "#E67E22", "#1ABC9C", "#34495E"
  ];

  // ✅ Map colors to specific payment terms (stable)
  const colorMap = {};
  listPayment?.forEach((item, i) => {
    colorMap[item.paymentTerm] = colorPalette[i % colorPalette.length];
  });

  // ✅ Legend items
  const legendItems = listPayment?.map((item) => ({
    label: item.paymentTerm,
    color: colorMap[item.paymentTerm],
  }));

  // ✅ Filter visible data for charts (stable colors)
  const filterVisible = (arr, field) =>
    listPayment
      ?.filter((item) => !hiddenTerms.includes(item.paymentTerm))
      ?.map((item) => item[field] || 0);

  const onTimeMTD = filterVisible(listPayment, "onTimeMTD");
  const onTimeYTD = filterVisible(listPayment, "onTimeYTD");
  const onTimeTotal = filterVisible(listPayment, "onTimeTotal");
  const lateMTD = filterVisible(listPayment, "lateMTD");
  const lateYTD = filterVisible(listPayment, "lateYTD");
  const lateTotal = filterVisible(listPayment, "lateTotal");

  const visibleLabels = listPayment
    ?.filter((item) => !hiddenTerms.includes(item.paymentTerm))
    ?.map((item) => item.paymentTerm);

  const visibleColors = listPayment
    ?.filter((item) => !hiddenTerms.includes(item.paymentTerm))
    ?.map((item) => colorMap[item.paymentTerm]);

  // ✅ Chart options (shared)
  const baseChartOptions = {
    chart: { type: "donut" },
    labels: visibleLabels,
    colors: visibleColors,
    legend: { show: false },
    // show value inside each slice
    dataLabels: {
      enabled: true,
      formatter: function (val, opts) {
        try {
          const idx = opts.seriesIndex;
          const value = opts.w.config.series[idx];
          return Number(value).toLocaleString();
        } catch (e) {
          return val;
        }
      },
      style: {
        fontSize: '12px',
        colors: ['#fff']
      },
      dropShadow: {
        enabled: false
      }
    },
    tooltip: {
      y: {
        formatter: (val) => val.toLocaleString(),
      },
    },
    plotOptions: {
      pie: {
        donut: {
          // keep centre label off (optional) — values are on slices
          labels: {
            show: false
          }
        }
      }
    },
  };

  // ✅ Handle toggle in legend
  const handleLegendClick = (term) => {
    setHiddenTerms((prev) =>
      prev.includes(term)
        ? prev.filter((t) => t !== term)
        : [...prev, term]
    );
  };

  return (
    <div className="payment-summary">
      {/* ✅ Clickable Legend */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "15px",
          marginBottom: "20px",
          flexWrap: "wrap",
        }}
      >
        {legendItems?.map((item, i) => {
          const isHidden = hiddenTerms.includes(item.label);
          return (
            <div
              key={i}
              onClick={() => handleLegendClick(item.label)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                cursor: "pointer",
                padding: "5px 10px",
                borderRadius: "4px",
                opacity: isHidden ? 0.4 : 1,
                border: isHidden ? "1px dashed #ccc" : "1px solid transparent",
                transition: "all 0.2s ease-in-out",
              }}
            >
              <span
                style={{
                  width: "20px",
                  height: "10px",
                  backgroundColor: item.color,
                  display: "inline-block",
                  borderRadius: "2px",
                }}
              ></span>
              <span style={{ fontSize: "14px", color: "#333" }}>{item.label}</span>
            </div>
          );
        })}
      </div>

      <Grid container spacing={2}>
        {/* ✅ TABLE SECTION (Always visible, no dimming) */}
        <Grid item xs={12} md={12} lg={6} xl={6}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                  <TableCell style={{ color: "black", fontWeight: 600, position: "sticky", left: 0, zIndex: 2, backgroundColor: "#EFF2F4" }}>Payment Term</TableCell>
                  <TableCell align="right" style={{ color: "black", fontWeight: 600, position: "sticky", left: "120px", zIndex: 2, backgroundColor: "#EFF2F4" }}>No. of Days</TableCell>
                  <TableCell align="right" style={{ color: "black", fontWeight: 600 }}>On Time (MTD)</TableCell>
                  <TableCell align="right" style={{ color: "black", fontWeight: 600 }}>On Time (YTD)</TableCell>
                  <TableCell align="right" style={{ color: "black", fontWeight: 600 }}>On Time (SELECTED DATE)</TableCell>
                  <TableCell align="right" style={{ color: "black", fontWeight: 600 }}>Late Payment (MTD)</TableCell>
                  <TableCell align="right" style={{ color: "black", fontWeight: 600 }}>Late Payment (YTD)</TableCell>
                  <TableCell align="right" style={{ color: "black", fontWeight: 600 }}>Late Payment (SELECTED DATE)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {listPayment?.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell style={{ position: "sticky", left: 0, zIndex: 2, backgroundColor: "#fff" }}>{row?.paymentTerm}</TableCell>
                    <TableCell align="right" style={{ position: "sticky", left: "120px", zIndex: 2, backgroundColor: "#fff" }}>{row?.paymentDays}</TableCell>
                    <TableCell align="right">{row?.onTimeMTD?.toLocaleString()}</TableCell>
                    <TableCell align="right">{row?.onTimeYTD?.toLocaleString()}</TableCell>
                    <TableCell align="right">{row?.onTimeTotal?.toLocaleString()}</TableCell>
                    <TableCell align="right">{row?.lateMTD?.toLocaleString()}</TableCell>
                    <TableCell align="right">{row?.lateYTD?.toLocaleString()}</TableCell>
                    <TableCell align="right">{row?.lateTotal?.toLocaleString()}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        {/* ✅ CHART SECTION (Toggles only here) */}
        <Grid item xs={12} md={12} lg={6} xl={6}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              justifyItems: "center",
              alignItems: "center",
              gap: "20px",
              padding: "10px 0",
            }}
          >
            <div style={{ width: "250px" }}>
              <p style={{ fontSize: 14, fontWeight: "bold", textAlign: "center" }}>On Time (MTD)</p>
              <ReactApexChart
                options={baseChartOptions}
                series={onTimeMTD}
                type="donut"
                width="100%"
              />
            </div>

            <div style={{ width: "250px" }}>
              <p style={{ fontSize: 14, fontWeight: "bold", textAlign: "center" }}>On Time (YTD)</p>
              <ReactApexChart
                options={baseChartOptions}
                series={onTimeYTD}
                type="donut"
                width="100%"
              />
            </div>

            <div style={{ width: "250px" }}>
              <p style={{ fontSize: 14, fontWeight: "bold", textAlign: "center" }}>Late Payment (MTD)</p>
              <ReactApexChart
                options={baseChartOptions}
                series={lateMTD}
                type="donut"
                width="100%"
              />
            </div>

            <div style={{ width: "250px" }}>
              <p style={{ fontSize: 14, fontWeight: "bold", textAlign: "center" }}>Late Payment (YTD)</p>
              <ReactApexChart
                options={baseChartOptions}
                series={lateYTD}
                type="donut"
                width="100%"
              />
            </div>

            <div style={{ width: "250px" }}>
              <p style={{ fontSize: 14, fontWeight: "bold", textAlign: "center" }}>On Time (Selected Date)</p>
              <ReactApexChart
                options={baseChartOptions}
                series={onTimeTotal}
                type="donut"
                width="100%"
              />
            </div>

            <div style={{ width: "250px" }}>
              <p style={{ fontSize: 14, fontWeight: "bold", textAlign: "center" }}>Late Payment (Selected Date)</p>
              <ReactApexChart
                options={baseChartOptions}
                series={lateTotal}
                type="donut"
                width="100%"
              />
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
